module.exports = __webpack_public_path__ + "media/images/icons/working-72a6fd455fff4bc3f627d5a38c1da531.svg";